import React, { useEffect, useState } from 'react';

import { SupplierInventoryDataResponse } from '@/main/models/response';
import { getTranslateByKey, isNullUndefined, isNullUndefinedEmpty } from '@/main/services/utils';
import { KeyValue } from '@/main/models/common';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';

import FormPriceList from './formPriceList/formPriceList';
import GridPriceList from './gridPriceList/gridPriceList';
import * as SP from '../styles';
import * as S from './styles';
import { supplierInventoryApi } from '@/main/api';

export interface IDataPriceList {
  idClient: string;
  guidSupplierInventoryWarehousePrice: string | null;
  companyType: KeyValue | null;
  company: KeyValue | null;
  priceLogisticCompany: string | number | null;
  priceAutoDeliveryWithoutCost: string | number | null;
  priceAutoDeliveryWithCost: string | number | null;
  isAllCompany: boolean;
  isNoPriceLogisticCompany: boolean;
  isNoPriceAutoDeliveryWithoutCost: boolean;
  isNoPriceAutoDeliveryWithCost: boolean;
}
interface ISectionPriceListProps {
  watcherCountry: KeyValue | null;
  dataPriceList: IDataPriceList[];
  dataInventory: SupplierInventoryDataResponse | null;
  setDataPriceList: React.Dispatch<React.SetStateAction<IDataPriceList[]>>;
}
function SectionPriceList({
  watcherCountry,
  dataPriceList,
  dataInventory,
  setDataPriceList,
}: ISectionPriceListProps) {
  const [idClientEdit, setIdClientEdit] = useState<string>('');
  const [isLoadingPriceList, setIsLoadingPriceList] = useState<boolean>(false);


  async function loadPriceList() {
    if (isNullUndefined(dataInventory)) return;

    setIsLoadingPriceList(true);

    supplierInventoryApi
      .getWarehousePartPrice(dataInventory.supplierInventoryWarehouseGuid)
      .then((response) => {
        const { data: { result } } = response;

        const formattedDataPriceList: IDataPriceList[] = result.map(item => ({
          ...(isNullUndefined(item.guidCompany) ? { company: null } : { company: { key: item.guidCompany, value: item.companyName } }),
          companyType: { key: item.idCompanyType, value: item.companyTypeName },
          priceAutoDeliveryWithCost: item.autoDeliveryPriceWithCost ?? '',
          priceAutoDeliveryWithoutCost: item.autoDeliveryPrice ?? '',
          priceLogisticCompany: item.shippingPrice ?? '',
          isNoPriceAutoDeliveryWithCost: isNullUndefinedEmpty(item.autoDeliveryPriceWithCost),
          isNoPriceAutoDeliveryWithoutCost: isNullUndefinedEmpty(item.autoDeliveryPrice),
          isNoPriceLogisticCompany: isNullUndefinedEmpty(item.shippingPrice),
          idClient: item.guidSupplierInventoryWarehousePrice ?? '',
          guidSupplierInventoryWarehousePrice: item.guidSupplierInventoryWarehousePrice ?? '',
          isAllCompany: isNullUndefined(item.guidCompany)
        }))

        setDataPriceList(formattedDataPriceList);
      })
      .finally(() => {
        setIsLoadingPriceList(false);
      })
  }

  useEffect(() => {
    loadPriceList();
  }, [dataInventory?.supplierInventoryWarehouseGuid])

  if (isLoadingPriceList) return (
    <S.Container>
      <SP.HeaderSection>
        <SP.HeaderText>
          {getTranslateByKey('information.priceList')}
        </SP.HeaderText>
      </SP.HeaderSection>
      <LoadingComponent />
    </S.Container>
  )

  return (
    <S.Container>
      <SP.HeaderSection>
        <SP.HeaderText>
          {getTranslateByKey('information.priceList')}
        </SP.HeaderText>
      </SP.HeaderSection>

      <FormPriceList
        watcherCountry={watcherCountry}
        idClientEdit={idClientEdit}
        setIdClientEdit={setIdClientEdit}
        dataPriceList={dataPriceList}
        setDataPriceList={setDataPriceList}
      />

      <GridPriceList
        setIdClientEdit={setIdClientEdit}
        dataPriceList={dataPriceList}
        setDataPriceList={setDataPriceList}
      />
    </S.Container>
  )
}

export default SectionPriceList